/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Hero_Title_TailInputs */

const en_features_hero_title_tail = /** @type {(inputs: Features_Hero_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in one app`)
};

const pl_features_hero_title_tail = /** @type {(inputs: Features_Hero_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w jednej aplikacji`)
};

/**
* | output |
* | --- |
* | "in one app" |
*
* @param {Features_Hero_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_hero_title_tail = /** @type {((inputs?: Features_Hero_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Hero_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_hero_title_tail(inputs)
	return en_features_hero_title_tail(inputs)
});